// src/main.js
import Konva from 'konva';

// Now you can use Konva in your code
var stage = new Konva.Stage({
  container: 'container',
  width: window.innerWidth,
  height: window.innerHeight,
});

var layer = new Konva.Layer({
  draggable: true
});
stage.add(layer);

// Adjust stage/canvas size if the window is resized
window.addEventListener('resize', () => {
    stage.width(window.innerWidth);
    stage.height(window.innerHeight);
    layer.draw(); // Redraw layer after resize
});

// --- Ball Object Definition ---
class Ball {
    constructor(x, y, radius, color, speed, angle) {
        this.radius = radius;
        this.color = color;
        this.speed = speed; // Overall speed magnitude
        this.angle = angle; // Angle in radians

        // Calculate initial velocity components from speed and angle
        this.vx = speed * Math.cos(angle);
        this.vy = speed * Math.sin(angle);

        // Create the Konva Circle shape
        this.circle = new Konva.Circle({
            x: x,
            y: y,
            radius: this.radius,
            fill: this.color,
//            listening: false // Set to false for background elements for performance
            draggable: true
        });

        layer.add(this.circle); // Add to the Konva layer
    }

    // Update position based on velocity
    update() {
        this.circle.x(this.circle.x() + this.vx);
        this.circle.y(this.circle.y() + this.vy);
    }

    // Handle bouncing off canvas walls
    bounceOffWalls(stageWidth, stageHeight) {
        const x = this.circle.x();
        const y = this.circle.y();

        // Check horizontal walls
        if (x - this.radius < 0 || x + this.radius > stageWidth) {
            this.vx *= -1; // Reverse horizontal velocity
            // Optional: push ball back slightly to prevent sticking
            if (x - this.radius < 0) this.circle.x(this.radius);
            if (x + this.radius > stageWidth) this.circle.x(stageWidth - this.radius);
        }

        // Check vertical walls
        if (y - this.radius < 0 || y + this.radius > stageHeight) {
            this.vy *= -1; // Reverse vertical velocity
            // Optional: push ball back slightly to prevent sticking
            if (y - this.radius < 0) this.circle.y(this.radius);
            if (y + this.radius > stageHeight) this.circle.y(stageHeight - this.radius);
        }
    }

    // Simple collision response for visual effect (bouncing off each other)
    // This is a basic elastic collision approximation.
    collide(otherBall) {
        const dx = otherBall.circle.x() - this.circle.x();
        const dy = otherBall.circle.y() - this.circle.y();
        const distance = Math.sqrt(dx * dx + dy * dy);

        // If circles are overlapping
        if (distance < this.radius + otherBall.radius) {
            // Calculate overlap amount
            const overlap = (this.radius + otherBall.radius) - distance;

            // Normalize the collision vector
            const nx = dx / distance;
            const ny = dy / distance;

            // Move balls apart slightly to prevent sticking
            this.circle.x(this.circle.x() - nx * overlap / 2);
            this.circle.y(this.circle.y() - ny * overlap / 2);
            otherBall.circle.x(otherBall.circle.x() + nx * overlap / 2);
            otherBall.circle.y(otherBall.circle.y() + ny * overlap / 2);

            // Simple velocity swap/reflection for visual bounce
            // (More complex physics involves calculating relative velocities and impulse)
            const tempVx = this.vx;
            const tempVy = this.vy;

            this.vx = otherBall.vx;
            this.vy = otherBall.vy;

            otherBall.vx = tempVx;
            otherBall.vy = tempVy;
        }
    }
}

// --- Animation Parameters ---
const NUM_BALLS = 30; // Number of circles you want
const BALL_RADIUS_MIN = 8;
const BALL_RADIUS_MAX = 15;
const BALL_SPEED_MIN = 0.5; // Pixels per frame
const BALL_SPEED_MAX = 1.5;
const BALL_COLOR = 'rgba(255, 255, 255, 0.6)'; // White with some transparency

const balls = [];

// --- Generate Balls ---
function generateBalls() {
    for (let i = 0; i < NUM_BALLS; i++) {
        const radius = BALL_RADIUS_MIN + Math.random() * (BALL_RADIUS_MAX - BALL_RADIUS_MIN);
        const x = radius + Math.random() * (stage.width() - 2 * radius); // Ensure ball starts within bounds
        const y = radius + Math.random() * (stage.height() - 2 * radius);
        const speed = BALL_SPEED_MIN + Math.random() * (BALL_SPEED_MAX - BALL_SPEED_MIN);
        const angle = Math.random() * Math.PI * 2; // Random angle in radians (0 to 2*PI)

        balls.push(new Ball(x, y, radius, BALL_COLOR, speed, angle));
    }
}

generateBalls();

// --- Konva Animation Loop ---
const anim = new Konva.Animation(function(frame) {
    const stageWidth = stage.width();
    const stageHeight = stage.height();

    // Update and bounce all balls off walls
    balls.forEach(ball => {
        ball.update();
        ball.bounceOffWalls(stageWidth, stageHeight);
    });

    // Check for collisions between balls
    // This is an O(N^2) operation, which can be slow for many balls.
    // For background effects, it's usually fine for up to 50-100 balls.
    for (let i = 0; i < balls.length; i++) {
        for (let j = i + 1; j < balls.length; j++) {
            balls[i].collide(balls[j]);
        }
    }

}, layer);

anim.start(); // Start the animation!